/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Busoro 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gitovu": ["Gitega", "Kabeza", "Kayenzi", "Muhindo", "Musumba", "Nazareti", "Nyacyonga", "Nyagasambu", "Rushoka"],
  "Kimirama": ["Gitwa", "Kimirama", "Kireranyana", "Ndamira", "Nyamiyonga", "Nyarugenge", "Rugarama"],
  "Masangano": ["Busoro", "Bweramana", "Gikombe", "Masangano", "Murambi", "Nyarugunga", "Runyonza", "Shinga"],
  "Munyinya": ["Kagarama", "Karambi", "Kigali", "Kivugiza", "Rwara"],
  "Rukingiro": ["Cyamugani", "Cyuriro", "Gasambu", "Runazi", "Rwanamiza", "Rwangoga"],
  "Shyira": ["Gahogo", "Kinkanga", "Nyamoyaga", "Rucyamo", "Rusharu", "Saruduha"]
};